__turbopack_context__.v({
  "column": "logos-carousel-module__ptu7Jq__column",
  "logoSlot": "logos-carousel-module__ptu7Jq__logoSlot",
  "mark": "logos-carousel-module__ptu7Jq__mark",
  "markImg": "logos-carousel-module__ptu7Jq__markImg",
  "root": "logos-carousel-module__ptu7Jq__root",
});
